module.exports = function(ejs) {
var __t, __p = '';
__p += '<div class="ggs-gallery-vote-count" ng-class=":: $ctrl.themeClass" ggs-attr="' +
((__t = ( ejs.LE?'':'::' )) == null ? '' : __t) +
' {\n    dir: $ctrl.ggsProperties.locale_dir\n  }" ' +
((__t = ( ejs.LE
    ? `ng-bind="$ctrl.getVotesCount()"`
    : `roe-bind="$ctrl.getVotesCount()"
       roe-bind-emitter=":: $ctrl.ggsPostVoteEmitter"`
  )) == null ? '' : __t) +
' ></div>';
return __p
}